// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
/* eslint-disable */
import Vue from 'vue'
import App from './App'
import router from './router'

//SET IDIOMA
localStorage.setItem('language', 'es');

//VUEX 
import Vuex from 'vuex'
Vue.use(Vuex)
import { store } from '@/store/store.js';
//.VUEX 

//AXIOS
import axios from 'axios'
import VueAxios from 'vue-axios'
axios.defaults.baseURL = store.state.server;
//.AXIOS


//IDIOMAS
import VueI18n from 'vue-i18n'
import messages from './translations';

Vue.use(VueI18n);

const i18n = new VueI18n({
	locale: localStorage.getItem('language'), 
	messages,
});
//.IDIOMAS

import 'animate.css'
import 'fullpage-vue/src/fullpage.css'
import VueFullpage from 'fullpage-vue'
Vue.use(VueFullpage)


Vue.config.productionTip = false

new Vue({
	el: '#app',
	router,
	i18n,
	store,
	components: { App },
	template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js